// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "viewer-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-RkOaxczZ_mjs":"24b64bbcf1150438464d","filerobot":"976d193ca2059b106460","plyr":"71222128a0106c83780e","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-DBGB1Rec_mjs":"783efc629b48bee195af"}[chunkId] + "";
};